module.exports = __webpack_public_path__ + "static/media/logo.ddafc7ff.svg";